<template>
  <div>
      <h2>我的证书</h2>
      <a-divider></a-divider>
      <!-- <iframe width="100%" height="800px" src="https://aice.org.cn/teaching/cert/query.html" frameborder="no"></iframe> -->
      <CertQuery/>
  </div>
</template>

<script>
import CertQuery from '../CertQuery'
export default {
  components:{
    CertQuery
  }
}
</script>

<style>

</style>